import React from 'react';

const VipInfo = ({vipInfo}) => {

    return (

<div className='event-detail__vipInfo'>
{vipInfo.map((item, index) => {
    // Render paragraphs
        if (item.type === 'paragraph') {
        return (
            <p key={index}>
            {item.children.map((child, childIndex) => (
                <span key={childIndex}>{child.text}</span>
            ))}
            </p>
        );
        }

        // Render unordered lists
        if (item.type === 'list' && item.format === 'unordered') {
        return (
            <ul key={index}>
            {item.children.map((listItem, listItemIndex) => (
                <li key={listItemIndex}>
                {listItem.children.map((child, childIndex) => (
                    <span key={childIndex}>{child.text}</span>
                ))}
                </li>
            ))}
            </ul>
        );
        }

    return null; // For any other types, return null (or handle other types if needed)
})}
</div>

    )

};

export default VipInfo;